import CookiePolicyPage from './views/cookiepolicy'
import TermsOfServicePage from './views/termsofservice'
import React from 'react'
import CookiePopup from './components/cookiepopup'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'

import './style.css'
import VCISOServices from './views/v-ciso-services'
import SourceCodeReview from './views/source-code-review'
import ThickClientApplicationSecurity from './views/thick-client-application-security'
import OTSecurity from './views/ot-security'
import VAPTAsAServiceOverview from './views/vapt-as-a-service-overview'
import CyberGovernanceAdvisory from './views/cyber-governance-advisory'
import FirewallConfigurationReview from './views/firewall-configuration-review'
import OperationalResilience from './views/operational-resilience'
import SOCAsAService from './views/soc-as-a-service'
import Blog from './views/blog'
import LLMPenetrationTesting from './views/llm-penetration-testing'
import AboutUs from './views/about-us'
import SecurityComplianceAssessments from './views/security-compliance-assessments'
import IoTSecurity from './views/io-t-security'
import SOCCompliance from './views/soc-compliance'
import InternalControlsDesignTesting from './views/internal-controls-design-testing'
import BlockchainSecurity from './views/blockchain-security'
import PCIDSSCompliance from './views/pci-dss-compliance'
import DataProtectionPrivacy from './views/data-protection-privacy'
import OTIoTSecurity from './views/ot-io-t-security'
import RedTeamExercises from './views/red-team-exercises'
import AIGovernanceRiskComplianceAIGRC from './views/ai-governance-risk-compliance-ai-grc'
import Home from './views/home'
import ContactUs from './views/contact-us'
import NetworkSecurityTesting from './views/network-security-testing'
import MobileApplicationSecurity from './views/mobile-application-security'
import APISecurityTesting from './views/api-security-testing'
import ApplicationSecurityDevSecOps1 from './views/application-security-dev-sec-ops1'
import VendorRiskManagement from './views/vendor-risk-management'
import CloudSecurityAssessment from './views/cloud-security-assessment'
import WebApplicationSecurity from './views/web-application-security'
import ISOStandardsAIGRCAIGovernanceRiskCompliance from './views/iso-standards-ai-grc-ai-governance-risk-compliance'
import NotFound from './views/not-found'
import PrivacyPolicyPage from './views/privacypolicy'
import RefundPolicyPage from './views/refundpolicy'
import DigitalForensics from './views/digital-forensics'
import IncidentResponse from './views/incident-response'

const App = () => {
  return (
    <>
      <CookiePopup />
      <Router>
        <Switch>
        <Route component={VCISOServices} exact path="/v-ciso-services" />
        <Route component={SourceCodeReview} exact path="/source-code-review" />
        <Route
          component={ThickClientApplicationSecurity}
          exact
          path="/thick-client-application-security"
        />
        <Route component={OTSecurity} exact path="/ot-security" />
        <Route
          component={VAPTAsAServiceOverview}
          exact
          path="/vapt-as-a-service-overview"
        />
        <Route
          component={CyberGovernanceAdvisory}
          exact
          path="/cyber-governance-advisory"
        />
        <Route
          component={FirewallConfigurationReview}
          exact
          path="/firewall-configuration-review"
        />
        <Route
          component={OperationalResilience}
          exact
          path="/operational-resilience"
        />
        <Route component={SOCAsAService} exact path="/soc-as-a-service" />
        <Route component={Blog} exact path="/blog" />
        <Route component={LLMPenetrationTesting} exact path="/llm-penetration-testing" />
        <Route component={AboutUs} exact path="/about-us" />
        <Route
          component={SecurityComplianceAssessments}
          exact
          path="/security-compliance-assessments"
        />
        <Route component={IoTSecurity} exact path="/io-t-security" />
        <Route component={SOCCompliance} exact path="/soc-compliance" />
        <Route
          component={InternalControlsDesignTesting}
          exact
          path="/internal-controls-design-testing"
        />
        <Route
          component={BlockchainSecurity}
          exact
          path="/blockchain-security"
        />
        <Route component={PCIDSSCompliance} exact path="/pci-dss-compliance" />
        <Route
          component={DataProtectionPrivacy}
          exact
          path="/data-protection-privacy"
        />
        <Route component={OTIoTSecurity} exact path="/ot-io-t-security" />
        <Route component={RedTeamExercises} exact path="/red-team-exercises" />
        <Route
          component={AIGovernanceRiskComplianceAIGRC}
          exact
          path="/ai-governance-risk-compliance-ai-grc"
        />
        <Route component={Home} exact path="/" />
        <Route component={ContactUs} exact path="/contact-us" />
        <Route
          component={NetworkSecurityTesting}
          exact
          path="/network-security-testing"
        />
        <Route
          component={MobileApplicationSecurity}
          exact
          path="/mobile-application-security"
        />
        <Route
          component={APISecurityTesting}
          exact
          path="/api-security-testing"
        />
        <Route
          component={ApplicationSecurityDevSecOps1}
          exact
          path="/application-security-dev-sec-ops1"
        />
        <Route
          component={VendorRiskManagement}
          exact
          path="/vendor-risk-management"
        />
        <Route
          component={CloudSecurityAssessment}
          exact
          path="/cloud-security-assessment"
        />
        <Route
          component={WebApplicationSecurity}
          exact
          path="/web-application-security"
        />
        <Route
          component={ISOStandardsAIGRCAIGovernanceRiskCompliance}
          exact
          path="/iso-standards-ai-grc-ai-governance-risk-compliance"
        />
          <Route component={PrivacyPolicyPage} exact path="/privacypolicy" />
          <Route component={RefundPolicyPage} exact path="/refundpolicy" />
          <Route component={DigitalForensics} exact path="/digital-forensics" />
          <Route component={IncidentResponse} exact path="/incident-response" />
          <Route component={TermsOfServicePage} exact path="/terms-of-service" />
          <Route component={CookiePolicyPage} exact path="/cookie-policy" />
          <Route component={NotFound} />
        </Switch>
      </Router>
    </>
  )
}

ReactDOM.render(<App />, document.getElementById('app'))
